<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>DNI/CIF</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.dni" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Fecha nacimiento</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" :config="configdateTimePicker" v-model="cliente.persona.fechaNacimiento" disabled />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Nombre o razón social</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.nombre" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.apellidos" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Móvil de contacto</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.telefono" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>E-mail</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.email" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Dirección del cliente (dirección de facturación)" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Dirección</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.direccion" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Núm.</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.numero" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Portal</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.portal" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Escalera</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.escalera" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Planta</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.planta" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Puerta</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.puerta" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Localidad</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.localidad" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Municipio</span>
          </div>
          <div>
            <select-val-municipio class="w-full" name="municipio" v-model="direccionCliente.municipio" :municipioSelected="direccionCliente.municipio"
              ref="cambiarEstado"  disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-2/12 w-full">
          <div>
            <span>Cód. Postal</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.cp" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-4/12 w-full">
          <div>
            <span>Provincia</span>
          </div>
          <div>
            <select-val-provincia class="w-full" name="provincia" v-model="direccionCliente.provincia" :provinciaSelected="direccionCliente.provincia" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <div>
            <span>Pais</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionCliente.pais" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Volver</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesViewCliente',
  components: {
    selectValMunicipio,
    selectValProvincia,
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      operacion: {},
      cliente: {},
      direccionCliente: {},
      clienteId: null,
      clienteTelefono: null,
      clienteEmail: null,
      clienteDireccionId: null,

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      }
    }
  },
  computed: {
  },
  methods: {
    reset_data () {
      this.$router.push({name: 'operaciones'})
    }
  },
  created () {
    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))
    if (this.cliente.hasOwnProperty('direccion')) this.direccionCliente = JSON.parse(JSON.stringify(this.cliente.direccion))
    this.clienteId = this.cliente.persona.id
    if (this.cliente.hasOwnProperty('direccion')) this.clienteDireccionId = this.cliente.direccion.id
    this.clienteTelefono = this.cliente.telefono
    this.clienteEmail = this.cliente.email
  }
}
</script>

